@if (!group) {
<div class="cd-radio" #cdRadio>
  @if (formControl) {
  <cds-radio [config]="config" [formControl]="formControl" [orientation]="orientation" ngDefaultControl></cds-radio>
  } @else {
  <cds-radio [config]="config" [ngModel]="value" (ngModelChange)="valueChange.emit($event)" [orientation]="orientation" ngDefaultControl></cds-radio>
  }
</div>
} @if (group && controlName) {
<div [formGroup]="group" class="cd-radio" #cdRadio>
  <cds-radio
    [formControlName]="controlName"
    [config]="config"
    [orientation]="orientation"
    (ngModelChange)="valueChange.emit($event)"
    ngDefaultControl></cds-radio>
</div>
}
